import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import useBodyClass from "hooks/useBodyClass";
import Loading from "components/atom/Loading/Loading";

function RouteInterceptor({ children, isAuthenticated, sessionExpired, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location }) =>
				isAuthenticated || sessionExpired ? (
					children
				) : (
					<Redirect
						to={{
							pathname: `${AUTH_PREFIX_PATH}/login`,
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}

export const Views = (props) => {
	const { locale, token, sessionExpired, location, direction } = props;
	const currentAppLocale = AppLocale[locale];
	useBodyClass(`dir-${direction}`);
	return (
		<IntlProvider
			locale={currentAppLocale.locale}
			messages={currentAppLocale.messages}
		>
			<Loading />
			<ConfigProvider
				locale={currentAppLocale.antd}
				direction={direction}
			>
				<Switch>
					<Route exact path="/">
						<Redirect to={APP_PREFIX_PATH} />
					</Route>
					<Route path={AUTH_PREFIX_PATH}>
						<AuthLayout direction={direction} />
					</Route>
					<RouteInterceptor
						path={APP_PREFIX_PATH}
						isAuthenticated={token}
						sessionExpired={sessionExpired}
					>
						<AppLayout direction={direction} location={location} />
					</RouteInterceptor>
				</Switch>
			</ConfigProvider>
		</IntlProvider>
	);
};

const mapStateToProps = ({ theme, auth }) => {
	const { locale, direction } = theme;
	const { token, sessionExpired } = auth;
	return { locale, token, sessionExpired, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
